"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var package_1 = require("./package");
var IncompatibleConversionTypeException = /** @class */ (function (_super) {
    __extends(IncompatibleConversionTypeException, _super);
    function IncompatibleConversionTypeException(currUnit, targetUnit, extraInfo) {
        var _this = this;
        var message;
        if (targetUnit instanceof package_1.PackageUnit) {
            message = "Tried to convert " + currUnit.Name + " to " + targetUnit.Name + " with a part unit of " + targetUnit.PartUnit.Name;
        }
        else if (currUnit instanceof package_1.PackageUnit) {
            message = "Tried to convert " + currUnit.Name + " with part unit " + currUnit.PartUnit.Name + " to " + targetUnit.Name;
        }
        else {
            message = "Tried to convert " + currUnit.Name + " to " + targetUnit.Name;
        }
        if (extraInfo) {
            message = message + " " + extraInfo;
        }
        _this = _super.call(this, message) || this;
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return IncompatibleConversionTypeException;
}(Error));
exports.IncompatibleConversionTypeException = IncompatibleConversionTypeException;
